<template>
  <div class="pay-invoice__wrapper">
    <div v-if="isLoading" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
    <div class="css-grid pay-invoice__header">
      <div class="pay-invoice__header-name">Pay Fuel Invoice</div>
    </div>
    <PaymentView v-if="showPaymentView"></PaymentView>
    <ErrorMessageView v-if="showErrorView"></ErrorMessageView>
    <SuccessMessageView v-if="showSuccessView"></SuccessMessageView>

    <div class="pay-invoice__footer"></div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import PaymentView from '../pay-invoice/PaymentView.vue';
  import ErrorMessageView from '../pay-invoice/ErrorMessageView.vue';
  import SuccessMessageView from '../pay-invoice/SuccessMessageView.vue';

  export default {
    name: 'PayInvoiceLayout',
    components: {
      MoonLoader,
      PaymentView,
      ErrorMessageView,
      SuccessMessageView,
    },
    computed: {
      ...mapGetters('payInvoice', ['currentSection', 'loaders']),
      showPaymentView() {
        return this.currentSection === 'billingInfo';
      },
      showErrorView() {
        return this.currentSection === 'errorMessage';
      },
      showSuccessView() {
        return this.currentSection === 'successMessage';
      },
      isLoading() {
        return this.loaders.submitting;
      }
    },
    mounted() {
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
    beforeRouteLeave(to, from, next) {
      this.$store.dispatch('payInvoice/resetForm');
      next();
    },
  };
</script>
